import { all, Div, H3, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import { structuredQuery, fixCasing } from 'model/SearchQuery'
import { selectedOutcomes } from 'model/EvidenceSearch'
import * as closeIcon from 'icons/close.svg'
import Icon from 'components/Icon'
import {GroupNamingDialog} from 'components/filter/GroupNamingDialog' 

export class OutcomeDropdown extends Dropdown.with('.attribute-dropdown') {
	ready({ selected, attributeType }) {
		this.headerAdded = false
		let query = structuredQuery.valueOf()
		let outcomes = structuredQuery.outcomes
		let outcomesArray = outcomes.valueOf()
		if (outcomesArray.length == 0) {
			this.items = [{
				content: Div([Span('.selector-checkbox.selector-selected', ['✓']), 'Find outcome ' + selected.label]),
				onclick: () => {
					outcomes.put([ selected ])
				}
			}]
		} else {
			let outcome = outcomesArray[0]
			let ids = outcome && (outcome.ids || [ outcome.id ])
			this.items = [{
				content: Div([
					Span('.selector-checkbox.selector-selected', [ '✓' ]),
					'New search for this outcome']),
				onclick: () => {
					outcomes.put([ selected ])
				}
			}]
			if (!ids.includes(selected.id))
				this.items.push({
					content: Div([
						Span('.selector-checkbox.selector-selected', [ '✓' ]),
						Span('.primary-attribute-label', [outcome.label]), Span('.logic-operator', ['OR'])]),
					onclick: () => {
						outcome.ids = ids.concat([selected.id])
						outcome.fromText = false
						outcomes.put(outcomesArray)
					}
				})
		}
		this.items.push({
			content: Div([
				Span('.selector-checkbox.selector-selected', [ '✓' ]),
				'New outcome group']),
			onclick: () => {
				let newCollection
				new GroupNamingDialog({
					type: 'group',
					// Outcome we intend to group this new group with
					groupWith: this.selected.label,
					onName: (newName) => { 
						newCollection = fixCasing(newName)
						outcomes.put([Object.assign({}, selected, {
							label: newCollection,
							fromText: false,
						})])
					}
				}).show()
			}
		})
		/*, {
			content: Div([Icon({ icon: closeIcon }), 'Unselect ' + selected.label]),
			onclick: () => {
				this.onSelection(false)
			}
		}*/
	}
	attached() {
		super.attached()
		this.prepend(H3('.compare-as',[
			'Group ' + this.selected.label + ' with:']))
	}
}
